export default __webpack_public_path__ + "84fd1c5c0de64c90075a461247eaf121.svg";